<template>
  <w-sliding-popup width="750px" ref="slidingPopup" title="제조사 검색" @close="onClose">
    <div slot="content">
      <el-row class="mr-b10" type="flex" justify="end">
        <el-button size="mini" @click="showSearchTool = !showSearchTool"><i class="fas fa-search" /></el-button>
      </el-row>
      <el-table-wrapper ref="companyTable" :data="companyList" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" :highlight-current-row="true"
      remote pagination :total="total" @row-click="onRowClick" @condition-change="onChangeCondition" row-class-name="c-pointer" />
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <el-button class="mr-r4" size="large" type="solid" @click="applyObjCompanyInfo">적용</el-button>
      <el-button size="large" @click="onClose">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import commonAPI from '@/api/config/common';

export default {
  name: 'WProductCompanyPopup',
  data() {
    return {
      showSearchTool: false,
      total: 0,
      selectedRow: null,
      companyList: [],
      columns: [
        {
          prop: 'objCompanyName',
          label: '제조사명',
          sortable: true,
          headerAlign: 'center',
          searchable: true,
          remoteProp: 'obj_company_name',
        },
      ],
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
      this.loadData();
    },
    close() {
      this.showSearchTool = false;
      this.$refs.companyTable.clearFilter();
      this.$refs.slidingPopup.close();
    },
    onClose() {
      this.showSearchTool = false;
      this.$refs.companyTable.clearFilter();
      this.$refs.slidingPopup.visible = false;
    },
    onRowClick(row) {
      this.selectedRow = row;
    },
    applyObjCompanyInfo() {
      this.$emit('select-company-id', this.selectedRow);
      this.close();
    },
    onChangeCondition() {
      this.loadData();
    },
    loadData() {
      this.$nextTick(() => {
        const params = this.$refs.companyTable.getParameter();
        commonAPI.getObjCompanyList(params).then((res) => {
          this.companyList = res.data.data;
          this.total = res.data.total;
        });
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/config/node/netdevice/popup/ProductCompanyPopup.vue